export const UPDATE_IS_AUTHENTICATED = 'UPDATE_IS_AUTHENTICATED'
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS'
export const OPEN_MOBILE_SIDEBAR = 'OPEN_MOBILE_SIDEBAR'
export const UPDATE_VERTIFICATION = 'UPDATE_VERTIFICATION'
